(function () {
	'use strict';
	var controllerId = 'sistemaUserAdd';

	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'sectionMenu', sistemaUserAdd]);

	function sistemaUserAdd($scope, $uibModalInstance, datacontext, common, sectionMenu) {
	    var getLogFn = common.logger.getLogFn;
	    var log = getLogFn(controllerId);
	    var logError = getLogFn(controllerId, 'logError');

		$scope.user = {};
		$scope.user.Attivato = true;

		$scope.ok = function (isValid) {
		    if ($scope.user.Email != $scope.user.ConfermaEmail)
		        logError("Le email non coincidono");
		    else
			if (isValid) {
			    addItem($scope.user).then(function (result) {			        
			        if (result == '502') logError('Username gi&agrave; registrata');
			        else if (!result || result.Id == null || result.Id == 0) $uibModalInstance.close(null);
                    else  $uibModalInstance.close(result);
			    });
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};		

		function addItem(item) {
			item.DtAttivazione = new Date();
			return datacontext.user_add(item).then(function (data) {
			    return data;
			});
		}
	}
})();